import * as types from '../constants/promoStack';

const initialState = {
    id: '',
    stackoverflow: [],
    found: 0,
    showing: 0,
    authorized: false,
    loading: false,
    error: false
};

const promoStack = (state = initialState, {
    type,
    ...action
}) => {
    switch (type) {
        case types.GET_PROMO_STACK:
            return {
                ...state,
                loading: true,
                error: false
            };

        case types.SET_PROMO_STACK:
            return {
                ...state,
                id: action.id,
                stackoverflow: action.stackoverflow,
                found: action.found,
                showing: action.showing,
                authorized: action.authorized,
                loading: false,
                error: false
            };

        case types.ERROR_PROMO_STACK:
            return {
                ...state,
                id: '',
                stackoverflow: [],
                found: 0,
                showing: 0,
                authorized: false,
                loading: false,
                error: true
            };

        default: return state;
    }
};

export default promoStack;